import styled, { css } from 'styled-components';
import breakpoint from '../../utils/style-utils';
import useUIContext from '~/ui/use-ui-context';

const dataAt = props => ({
	'data-at': props.dataAt
});

const ActionScreenHeadWrapper = styled.section.attrs(dataAt)`
	padding: 56px 12px;
	text-align: center;
	svg {
		fill: var(--section-head-main-icon, rgba(var(--base-01), 1));
		height: 56px;
		margin: 0 auto;
		width: 56px;
	}
	.page-head__close svg {
		width: 24px;
		height: 24px;
	}
	@media only screen and (max-width: 480px) {
		padding: 40px 12px 64px 12px;
	}
`;

const ActionScreenMainTitle = styled.h2.attrs(dataAt)`
	color: var(--main-title, rgba(var(--base-01), 1));
	font: var(--h2);
	margin: 8px 0 2px 0;
	padding: 0 12px;
`;

const ActionScreenSubTitle = styled.p.attrs(dataAt)`
	color: var(--main-subtitle, rgba(var(--base-01), 1));
	font: var(--label-regular);
	margin: 0 auto;
	max-width: 600px;
	padding: 0 32px;
`;

const ActionScreenButton = styled.button.attrs(dataAt)`
	background-color: ${({ actionType }) =>
		(actionType === 'default-success' && 'rgba(255,255,255, 0.3)') ||
		(actionType === 'default-failure' && 'rgba(0, 0, 0, 0.3)') ||
		(actionType === 'responsible-gaming' && 'rgba(255, 255, 255, 0.3)')};
`;

const ActionScreenLabelBlock = styled.div.attrs(dataAt)`
	text-align: center;
	margin-bottom: ${props => (props.landscape ? '16px' : '48px')};
`;

const ActionScreenLabel = styled.label.attrs(dataAt)`
	font: var(--label-regular);
	color: ${props =>
		props.notInverted ? 'rgba(0, 0, 0, 1)' : 'rgba(var(--time-limit-reached-label-color, var(--base-07)), 1)'};
`;

const ActionScreenValue = styled.h2.attrs(dataAt)`
	font: var(--h2);
	color: ${props =>
		props.notInverted ? 'rgba(0, 0, 0, 1)' : 'rgba(var(--time-limit-reached-timer-color, var(--base-07)), 1)'};
`;

const ActionScreenLabelWithValue = ({ label, value, landscape }) => (
	<ActionScreenLabelBlock dataAt="label-block" landscape={landscape}>
		<ActionScreenLabel dataAt="label">{label}</ActionScreenLabel>
		<ActionScreenValue dataAt="value">{value}</ActionScreenValue>
	</ActionScreenLabelBlock>
);

const ActionScreenStyled = styled.div.attrs(dataAt)`
	background-color: ${({ type }) =>
		(type === 'default-success' && 'rgba(var(--success), 1)') ||
		(type === 'default-failure' && 'rgba(var(--error), 1)') ||
		(type === 'responsible-gaming' && 'rgba(var(--info), 1)')};
	left: 0;
	min-height: ${({ hasStaticHeader }) => (hasStaticHeader ? `calc(100% - var(--regulationHeight))` : '100%')};
	position: fixed;
	right: 0;
	top: ${({ hasStaticHeader }) => (hasStaticHeader ? `var(--regulationHeight)` : '0')};
	${breakpoint.lg`
		${({ uiContext }) =>
			uiContext &&
			uiContext.withinSidebar &&
			css`
				min-height: 100%;
				padding-top: 0;
				position: absolute;
				top: 0;
			`}
	`};
`;

const ActionScreen = props => {
	const uiContext = useUIContext();
	return <ActionScreenStyled {...props} uiContext={uiContext} />;
};

export {
	ActionScreenButton,
	ActionScreenLabelWithValue,
	ActionScreenHeadWrapper,
	ActionScreenMainTitle,
	ActionScreenSubTitle
};

export default ActionScreen;
